import React from 'react';

import Utils from 'files/Utils.js';

const PRIMARY_GREEN = '#1B5E20';
const SECONDARY_DARK = '#242F3F';

const FIRE = '#D63D1F';

const Footer = ({ onManageCookies }) => {

    const isMobile = Utils.isMobile();

    return (
        <footer style={{
            backgroundColor: SECONDARY_DARK,
            borderTop: '1px solid rgba(220,220,220,0.2)',
            padding: '32px 0',
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: 1280,
                padding: '0 16px',
                width: '100%'
            }}>
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 24,
                    justifyContent: 'space-between'
                }}>
                    <div style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 12
                    }}>
                        <i
                        className={'fas fa-shield-halved'}
                        style={{
                            color: PRIMARY_GREEN,
                            fontSize: 32
                        }} />
                        <span style={{
                            color: '#FFFFFF',
                            fontFamily: '"Montserrat", "Poppins", sans-serif',
                            fontSize: 20,
                            fontWeight: 700
                        }}>{'OmniShield'}</span>
                    </div>
                    <div style={{
                        alignItems: isMobile ? 'center' : 'flex-end',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    }}>
                        <p style={{
                            color: 'rgba(255,255,255,0.8)',
                            fontFamily: '"Lato", sans-serif',
                            fontSize: 14,
                            margin: 0,
                            textAlign: isMobile ? 'center' : 'right',
                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}>{`© ${new Date().getFullYear()} OmniShield. All rights reserved. Complete home protection you can trust.`}</p>
                        <button
                        type={'button'}
                        onClick={onManageCookies}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: FIRE,
                            cursor: 'pointer',
                            fontFamily: '"Lato", sans-serif',
                            fontSize: 13,
                            fontWeight: 600,
                            padding: 0,
                            textDecoration: 'underline'
                        }}>{'Cookie Preferences'}</button>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
